import React, { useContext } from 'react';
import { Select } from 'antd';
import { GlobalFiltersContext } from '../../GlobalFiltersContext';
import {
  OrderType,
  sortByOptions
} from '../../../../../components/v2/searchHelpers';
import { GlobalOrder } from '../../styles';

export const OrderFilter = () => {
  const { Option } = Select;

  const { advancedData, order, setOrder, updateData, setPage } =
    useContext(GlobalFiltersContext);

  const validAdvanced = advancedData.filter((e) => e.text.length > 0);
  const validAdvanceds = validAdvanced.length > 0;
  sortByOptions[0].show = validAdvanceds;

  const onSelect = (val: OrderType) => {
    setOrder(val);
    setPage(1);
    updateData();
  };

  return (
    <GlobalOrder>
      <Select
        optionLabelProp="title"
        filterOption={false}
        onSelect={onSelect}
        value={order}>
        {sortByOptions
          .filter((e) => e.show)
          .map((d, i) => (
            <Option key={i} value={d.value} title={d.title}>
              {d.title}
            </Option>
          ))}
      </Select>
    </GlobalOrder>
  );
};
